/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditAwareSearchRequest
 */
export interface CreditAwareSearchRequest {
    /**
     * Origin airport IATA code (e.g. JFK)
     * @type {string}
     * @memberof CreditAwareSearchRequest
     */
    origin: string;
    /**
     * Destination airport IATA code (e.g. LAX)
     * @type {string}
     * @memberof CreditAwareSearchRequest
     */
    destination: string;
    /**
     * 
     * @type {Date}
     * @memberof CreditAwareSearchRequest
     */
    departureDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreditAwareSearchRequest
     */
    returnDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof CreditAwareSearchRequest
     */
    passengers?: number;
}

/**
 * Check if a given object implements the CreditAwareSearchRequest interface.
 */
export function instanceOfCreditAwareSearchRequest(value: object): value is CreditAwareSearchRequest {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('destination' in value) || value['destination'] === undefined) return false;
    if (!('departureDate' in value) || value['departureDate'] === undefined) return false;
    return true;
}

export function CreditAwareSearchRequestFromJSON(json: any): CreditAwareSearchRequest {
    return CreditAwareSearchRequestFromJSONTyped(json, false);
}

export function CreditAwareSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditAwareSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': json['origin'],
        'destination': json['destination'],
        'departureDate': (new Date(json['departure_date'])),
        'returnDate': json['return_date'] == null ? undefined : (new Date(json['return_date'])),
        'passengers': json['passengers'] == null ? undefined : json['passengers'],
    };
}

export function CreditAwareSearchRequestToJSON(json: any): CreditAwareSearchRequest {
    return CreditAwareSearchRequestToJSONTyped(json, false);
}

export function CreditAwareSearchRequestToJSONTyped(value?: CreditAwareSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'origin': value['origin'],
        'destination': value['destination'],
        'departure_date': value['departureDate'].toISOString().substring(0,10),
        'return_date': value['returnDate'] == null ? value['returnDate'] : value['returnDate'].toISOString().substring(0,10),
        'passengers': value['passengers'],
    };
}

